import { selector } from "recoil";

import axios from "@utils/axios";
import { PublicSettingsType } from "types/admin";

/**
 * 로그인하기 **전에** 화면이 알아야 하는 설정.
 *
 * 로그인 화면은 본인인증이 켜져 있을 때만 «메일 링크를 누르면 휴대폰 인증이
 * 나옵니다» 를 알려야 하고, 가입 신청 폼은 켜져 있을 때만 인증 칸을 그려야 한다.
 * 둘 다 토큰이 없는 화면이라 관리자용 설정 목록을 읽을 수 없다.
 *
 * **못 읽으면 «꺼짐» 으로 본다.** 안내를 못 띄우는 것과, 켜져 있지도 않은 인증을
 * 요구해 아무도 가입을 못 하는 것 중에서는 전자가 낫다. 실제 판정은 어차피
 * 서버가 다시 한다 — 이 값은 화면을 그리기 위한 것이지 관문이 아니다.
 */
export const publicSettingsQuery = selector<PublicSettingsType>({
  key: "publicSettings",
  get: async () => {
    try {
      const response = await axios.get("settings/public");
      return response.data;
    } catch {
      return { identityOnLogin: false, identityOnSignup: false };
    }
  },
});
